export default function ($translate) {
    return {
        KEYS: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE'
        },
        LABELS: {
            ACTIVE: $translate.instant('questionPool.Active'),
            INACTIVE: $translate.instant('questionPool.Inactive')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/pool/index.js